
<div class="modal fade" id='popupID-temperatura-roteiro' tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
  style="z-index: 9999;" aria-hidden="true" data-bs-keyboard="false">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">    
      <div class="loading-temperatura-roteiro" *ngIf="popupTemperaturaRoteiroService.loading"><img class="img-loading me-1" src="assets/img/loading-preto.gif"  width="32px"/> Consultando temperatura do roteiro...</div> 
      <div class="modal-header justify-content-between">
        <h5 class="modal-title"> Temperatura do Roteiro </h5>
        <img id="btnCloseModalTemperaturaRoteiro" data-bs-dismiss="modal" class='bt-fechar me-3' src="assets/img/icons/close-white.svg"  >
      </div>
      <div class="modal-body"> 
        <div class='col' style='width: 100%;'>       
          <div #chartContainer style="width: 100%; height: 400px;" ></div>
        </div>
      </div>  
    </div>
  </div>
</div>
